import React from "react";
import { Crown } from "lucide-react";
import { useI18n } from "../../i18n/I18nContext";

const PremiumBadge = () => {
  const { t } = useI18n();
  return (
    <span className="inline-flex items-center gap-1 bg-[#c9a227] text-white text-[10px] font-700 uppercase tracking-wider px-2 py-0.5 rounded">
      <Crown className="w-3 h-3" /> {t("premium")}
    </span>
  );
};

export default PremiumBadge;
